module.exports = __webpack_public_path__ + "img/矢量智能对象(2).6cddba87.png";